<main id="content" class="bg-white">
  <div class="bg-paws-header border-bottom content-header">
    <h1 class="d-inline-flex pe-3 mb-0">Apps and Services</h1>
  </div>
  <div class="bg-white content-body" id="listWrapper">

    <div class="mx-0">
      @if ( showRoleFilter ) {
        <div ngbDropdown class="dropdown d-inline-block">
          <button type="button" class="btn btn-outline-secondary mx-1" id="dropdown_list" ngbDropdownToggle title="Available to">
            <span class="fw-bold">Available to</span>
          </button>
          <div ngbDropdownMenu class="bg-white">
            <button ngbDropdownItem class="dropdown-item" [class.active]="roleFilter.includes(STUDENT_FILTER)" href="#" (click)="toggleRoleFilter(STUDENT_FILTER)">
              @if ( roleFilter.includes(STUDENT_FILTER) ) {
                <!--                                <i class="bi bi-check-circle-fill me-1"></i>-->
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle-fill me-1" viewBox="0 0 16 16">
                  <circle cx="8" cy="8" r="8"/>
                </svg>
              } @else {
                <!--                                <i class="bi bi-circle me-1"></i>-->
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle me-1" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                </svg>
              }
            Students</button>
            <button ngbDropdownItem class="dropdown-item " [class.active]="roleFilter.includes(EMPLOYEE_FILTER)" href="#" (click)="toggleRoleFilter(EMPLOYEE_FILTER)">
              @if ( roleFilter.includes(EMPLOYEE_FILTER) ) {
                <i class="bi bi-check-circle-fill me-1"></i>
              } @else {
                <!--                                <i class="bi bi-circle me-1"></i>-->
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-circle me-1" viewBox="0 0 16 16">
                  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
                </svg>
              }
            Employees</button>
          </div>
        </div>
      }
      <div ngbDropdown class="d-inline-block">
        <button type="button" class="btn btn-outline-secondary mx-1" id="dropdownCategory" ngbDropdownToggle title="Category">
          <span class="fw-bold">Category</span>
        </button>
        <div ngbDropdownMenu class=" bg-white">
          @for ( parentCat of channelCategoryList; track $index ) {
            @if ( parentCat.is_visible ) {
              <button ngbDropdownItem class="dropdown-item my-2" [class.active]="categoryFilter.includes( parentCat.category.title )" (click)="toggleCategoryFilter(parentCat.category.title)">
                @if ( categoryFilter.includes( parentCat.category.title ) ) {
                  <!--                                    <i class="bi bi-check-square-fill me-1"></i>-->
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-square-fill me-1" viewBox="0 0 16 16">
                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"/>
                  </svg>
                } @else {
                  <!--                                    <i class="bi bi-square me-1"></i>-->
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-square me-1" viewBox="0 0 16 16">
                    <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"/>
                  </svg>
                }
                {{ parentCat.category.title }}
              </button>
            }
          }
        </div>
      </div>
      @if ( viewType == 'category' ) {
        <button type="button" class="btn btn-outline-primary mx-1 fw-bold" (click)="toggleView();" title="Click for Category View">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-list-ul mainIcon" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M5 11.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5m-3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2m0 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2"/>
          </svg>
          List <span class="d-none d-sm-inline-block">View</span>
        </button>
      }
      @if ( viewType == 'list' ) {
        <button type="button" class="btn btn-outline-primary mx-1 fw-bold" (click)="toggleView();" title="Click for List View">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-columns-gap mainIcon" viewBox="0 0 16 16">
            <path d="M6 1v3H1V1zM1 0a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zm14 12v3h-5v-3zm-5-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1zM6 8v7H1V8zM1 7a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1zm14-6v7h-5V1zm-5-1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1z"/>
          </svg>
          Grid <span class="d-none d-sm-inline-block">View</span>
        </button>
      }
    </div>
    @if ( categoryFilter.length > 0 || roleFilter.length > 0 ) {
      <div class="row m-3">
        <div class="col px-0 ">
          @for ( filter of roleFilter; track $index ) {
            <button type="button" class="btn btn-secondary btn-sm me-1 mb-1" (click)="toggleRoleFilter(filter)">
              {{ filter | titlecase }}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          }
          @for ( filter of categoryFilter; track $index ) {
            <button type="button" class="btn btn-secondary btn-sm me-1 mb-1" (click)="toggleCategoryFilter(filter)">
              {{ filter | titlecase }}
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
              </svg>
            </button>
          }
          <button class="btn btn-link mx-2" (click)="resetFilters()">Clear Filters</button>
        </div>
      </div>
    }
    <div class="portlets-list maxWidthWrapper" id="categoryView" [class.d-none]="viewType=='list'">
      <div class="row">
        <div class="col-xs-12 col-lg-6 m-0 p-0">
          @for ( cat of categoryFilteredList; track $index ) {
            @if ( $index%2 === 0 && isFilteredParentCategory( cat.category.title ) ) {
              <ng-container *ngTemplateOutlet="parentCategoryTemplate;context:{parentCat:cat}"></ng-container>
            }
          }
        </div>
        <div class="col-xs-12 col-lg-6 m-0 p-0">
          @for ( cat of categoryFilteredList; track $index ) {
            @if ( $index%2 === 1 && isFilteredParentCategory( cat.category.title ) ) {
              <ng-container *ngTemplateOutlet="parentCategoryTemplate;context:{parentCat:cat}"></ng-container>
            }
          }
        </div>
      </div>
    </div>
    <div class="bg-white" id="listView" [class.d-none]="viewType=='category'">
      <div class="portlets-list maxWidthWrapper" id="portlet-search-panel">
        <div class="row align-items-start">
          @for ( parentCat of channelCategoryList; track $index ) {
            @if ( ( parentCat.channels.length > 0 || parentCat.subCategories.length > 0 ) && isFilteredParentCategory( parentCat.category.title ) ) {
              <h2 class="h1 fw-bold portlet-category mt-2">{{ parentCat.category.title }}</h2>
              @if ( parentCat.channels.length > 0 ) {
                @for ( channel of parentCat.channels; track $index ) {
                  @if ( showChannel(channel) ) {
                    <ng-container *ngTemplateOutlet="channelListingTemplateNew;context:{channel:channel}"></ng-container>
                  }
                }
              }
              @if ( parentCat.subCategories.length > 0 && isFilteredParentCategory( parentCat.category.title ) ) {
                @for ( subCat of parentCat.subCategories; track $index ) {
                  @if ( subCat.channels.length > 0 ) {
                    @if ( showSubCatTitle( subCat ) ) {
                      <h3 class="h4 portlet-category mt-2 border-bottom">{{ subCat.category.title }}</h3>
                    }
                    @for ( channel of subCat.channels; track $index ) {
                      @if ( showChannel(channel) ) {
                        <ng-container *ngTemplateOutlet="channelListingTemplateNew;context:{channel:channel}"></ng-container>
                      }
                    }
                  }
                }
              }
            }
          }
        </div>
      </div>
    </div>
    <div class="m-4 d-none" id="noResultsFound">
      <p class="h4">No Results Found</p>
      <p>We couldn’t find anything matching your selected filters. Try adjusting your filters or clearing some of them to see more options.</p>
    </div>
  </div>
</main>
<ng-template #parentCategoryTemplate let-parentCat="parentCat">
  <div class="card" id="category_{{ parentCat.category.id }}">
    <div class="card-header">
      <h4 class="my-1 fw-bold">{{ parentCat.category.title }}</h4>
    </div>
    <div class="card-body p-0">
      @if ( parentCat.subCategories.length > 0 ) {
        <div class="accordion">
          @for ( subParentCat of parentCat.subCategories; track $index; ) {
            <div class="accordion-item">
              <h5 class="accordion-header p-3 m-0" [class.open]="subParentCat.is_visible" id="heading_{{$index}}" (click)="subParentCat.is_visible = !subParentCat.is_visible">
                <span class="accordion-button d-block text-primary fw-bold" aria-expanded="true" aria-controls="collapse_{{$index}}">
                  {{ subParentCat.category.title }}
                  @if ( subParentCat.is_visible == true ) {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-up float-end" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708z"/>
                    </svg>
                  } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down float-end" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                    </svg>
                  }
                </span>
              </h5>
              <div [@openClose]="subParentCat.is_visible ? 'open' : 'closed'" id="collapse_{{$index}}" aria-labelledby="heading_{{$index}}" style="overflow:hidden;" class="border-bottom subCategory px-3">
                @if ( subParentCat.channels.length > 0 ) {
                  @for ( channel of subParentCat.channels; track $index ) {
                    @if ( showChannel(channel) ) {
                      <ng-container *ngTemplateOutlet="channelListingTemplateNew;context:{channel:channel}"></ng-container>
                    }
                  }
                }
              </div>
            </div>
          }
        </div>
      } @else if ( parentCat.channels.length > 0 ){
        <div class="p-4">
          @for ( channel of parentCat.channels; track $index ) {
            @if ( showChannel(channel) ) {
              <ng-container *ngTemplateOutlet="channelListingTemplateNew;context:{channel:channel}"></ng-container>
            }
          }
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #channelListingTemplate let-channel="channel">
  <div class="portlet-item my-4 px-2" [class.studentChannel]="isStudentChannel( channel )" [class.employeeChannel]="isEmployeeChannel( channel )" [class.noAccess]="!userHasFullAccess( channel )">
    <div class="mb-3">
      <p class="h5 mb-0 portlet-title"><a [routerLink]="['/', channel.goname]" (click)="sendGAClickEvent(channel.title)"><b>{{ channel.title }}</b></a></p>
      <p class="portlet-description mb-0">{{ channel.description }}</p>
    </div>
  </div>
</ng-template>
<ng-template #channelListingTemplateNew let-channel="channel">
  <!--    <p>{{ channel.title }} - {{ showChannel(channel) }} - {{ isStudentChannel( channel ) }} - {{ isEmployeeChannel( channel ) }} - {{ !userHasFullAccess( channel ) }}</p>-->
  <div class="portlet-item my-2" [class.studentChannel]="isStudentChannel( channel )" [class.employeeChannel]="isEmployeeChannel( channel )" [class.noAccess]="!userHasFullAccess( channel )">
    <div class="mb-3 clearfix">
      <p class="h5 mb-0 portlet-title"><a [routerLink]="['/', channel.goname]" (click)="sendGAClickEvent(channel.title)"><b>{{ channel.title }}</b></a></p>
      <p class="portlet-description mb-0">{{ channel.description }}</p>
      @if (showChannelEligibility) {
        <div class="portlet-description mb-0 text-muted d-none">
          <div><strong>Eligibility:</strong> {{ channel.eligibility }}</div>
          <div class="fw-bold">
            @if ( channel.is_public ) {
              <span class="badge bg-secondary me-1">Public Channel</span>
            }
            @if ( isStudentChannel( channel ) ) {
              <span class="badge text-bg-primary me-1">Student Channel</span>
            }
            @if ( isEmployeeChannel( channel ) ) {
              <span class="badge text-bg-info">Employee Channel</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #visibleChannelListingTemplate let-channel="channel">
  <div class="portlet-item py-4 px-2">
    <div class="mb-3 bg-warning">
      <p class="h5 mb-0 text-muted"><b>2: {{ channel.title }}</b></p>
      <p class="portlet-description mb-0 text-muted">{{ channel.description }}</p>
      @if (showChannelEligibility) {
        <p class="portlet-description mb-0 text-muted"><strong>Eligibility:</strong> {{ channel.eligibility }}</p>
      }
      <p class="portlet-description mb-0 text-muted small"><strong>GoName:</strong> /{{ channel.goname }}</p>
    </div>
  </div>
</ng-template>
<ng-template #ineligibleChannelListingTemplate let-channel="channel">
  <div class="portlet-item my-4">
    <div class="mb-3">
      <p class="h5 mb-0 text-muted">3: <b>{{ channel.title }}</b></p>
      <p class="portlet-description mb-0 text-muted">{{ channel.description }}</p>
      @if (showChannelEligibility) {
        <p class="portlet-description mb-0 text-muted"><strong>Eligibility:</strong> {{ channel.eligibility }}</p>
      }
      <!--        <p class="portlet-description mb-0 text-muted small"><strong>GoName:</strong> /{{ channel.goname }}</p>-->
    </div>
  </div>
</ng-template>

<ng-template #eligibilityTemplate let-channel="channel">
  <p class="portlet-description mb-0"><strong>Eligibility:</strong> {{ channel.eligibility }}</p>
  <div class="card p-2">
    <p class="card-text mb-0"><strong>Eligibility:</strong> {{ channel.eligibility }}</p>
    <p class="card-text">
      @if (channel.is_public) {
        <span class="ms-2 badge text-bg-info">PUBLIC</span>
      }
      @for (r of channel.included_roles; track r) {
        <span class="ms-2 badge" [class.text-bg-success]="hasRole(r)" [class.text-bg-light]="!hasRole(r)">{{ r | uppercase }}</span>
      }
      @for (r of channel.excluded_roles; track r) {
        <span class="ms-2 badge" [class.text-bg-danger]="hasRole(r)" [class.text-bg-light]="!hasRole(r)">{{ r | uppercase }}</span>
      }
    </p>
  </div>
</ng-template>
